module.exports = __webpack_public_path__ + "img/navigation-banner-all.8f4b02be.png";